export const labelChannel = [
	{ value: 'STORE', label: 'Loja' },
	{ value: 'WHATSAPP', label: 'WhatsApp' },
	{ value: 'ECOMMERCE', label: 'E-commerce' },
	{ value: 'DESK', label: 'Mesa' },
	{ value: 'EMAIL', label: 'E-mail' },
	{ value: 'TELEPHONE', label: 'Telefone' },
]

export const CustomerProfile = [
	{ value: 'B2B_RETAIL', label: 'B2B Revenda' },
	{ value: 'B2B_CONSUMPTION', label: 'B2B Consumo' },
	{ value: 'OTHERS', label: 'Outros (descreva)' },
]

export const SetVision = [
	{ value: 'TICKET', label: 'Ticket' },
	{ value: 'ORDER', label: 'Pedido' },
	{ value: 'REVENUE', label: 'Faturamento' },
]

export const SeparationStages = [
	{ value: 'SEPARATION_PENDING', label: 'Pendente' },
	{ value: 'SEPARATION_ON_SEPARATION', label: 'Em Separação' },
	{ value: 'SEPARATION_SEPARATED', label: 'Separado' },
	{ value: 'SEPARATION_ON_CHECKING', label: 'Em Conferência' },
	{ value: 'SEPARATION_CHECKED', label: 'Conferido' },
]

export const COMMERCIAL_START_HOUR = 6
export const COMMERCIAL_END_HOUR = 22

export const DEFAULT_VALUE_OF_AMOUNT_SCHEDULE_DATE_OPTIONS = 14

export const WITHDRAWAL_MESSAGE = {
	PARAMS_NOT_FOUND:
		'Os parâmetros de separação desta loja ainda não foram configurados!',
	PLUGIN_PENDING_APPROVAL: 'Encaixe pendente de aprovação',
	PLUGIN_WAS_NOT_POSSIBLE: 'O encaixe não foi possível',
	PLUGIN_WAS_APPROVED: 'A solicitação de encaixe foi aprovada',
	DATE_HAS_BEEN_CHANGED_SUCCESSFULLY:
		'A data de retirada foi alterada com sucesso',
}

export const shifts = [
	{ value: 'morning', label: 'Manhã' },
	{ value: 'afternoon', label: 'Tarde' },
]

export const unitOpenHours = [
	{ value: '5h', label: '05:00' },
	{ value: '5h30', label: '05:30' },
	{ value: '6h', label: '06:00' },
	{ value: '6h30', label: '06:30' },
	{ value: '7h', label: '07:00' },
	{ value: '7h30', label: '07:30' },
	{ value: '8h', label: '08:00' },
	{ value: '8h30', label: '08:30' },
	{ value: '9h', label: '09:00' },
	{ value: '9h30', label: '09:30' },
	{ value: '10h', label: '10:00' },
	{ value: '10h30', label: '10:30' },
	{ value: '11h', label: '11:00' },
	{ value: '11h30', label: '11:30' },
	{ value: '12h', label: '12:00' },
	{ value: '12h30', label: '12:30' },
	{ value: '13h', label: '13:00' },
	{ value: '13h30', label: '13:30' },
	{ value: '14h', label: '14:00' },
	{ value: '14h30', label: '14:30' },
	{ value: '15h', label: '15:00' },
	{ value: '15h30', label: '15:30' },
	{ value: '16h', label: '16:00' },
	{ value: '16h30', label: '16:30' },
	{ value: '17h', label: '17:00' },
	{ value: '17h30', label: '17:30' },
	{ value: '18h', label: '18:00' },
	{ value: '18h30', label: '18:30' },
	{ value: '19h', label: '19:00' },
	{ value: '19h30', label: '19:30' },
	{ value: '20h', label: '20:00' },
	{ value: '20h30', label: '20:30' },
	{ value: '21h', label: '21:00' },
	{ value: '21h30', label: '21:30' },
	{ value: '22h', label: '22:00' },
	{ value: '22h30', label: '22:30' },
	{ value: '23h', label: '23:00' },
]
